import React from 'react';
import { ReactComponent as IconArrowRight } from 'images/arrow-right.svg';
import { Link } from 'react-router-dom';
import styles from './ViewAll.module.scss';
import { useTranslation } from 'react-i18next';

function ViewAll({ url }: { url?: string }) {
  const {t} = useTranslation() as any
  const href = url || ''
  return (
    <Link to={href} className={styles.viewAll}>
      {t('See All')}
      <IconArrowRight />
    </Link>
  )
}

export default ViewAll
